import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {SlideTree} from './SlideTree';
import {DesignChapter} from '@learningblocks/storybook-components';
import {Wrapper} from './Wrapper';
import {StreakCounter} from './StreakCounter';
import {StepViewComplete} from './StepViewComplete';
import {TechniqueViewComplete} from './TechniqueViewComplete';
import {Hint} from './Hint';

import './style.scss';

export function DesignChapterMob(props) {
  const appylHint = () => {
    if (props.viewType === 'STEPS') props.viewThreeHint();
    else props.viewFourHint();
  };

  return (
    <DesignChapter.Wrapper className='designChapterMob'>
      <StreakCounter />
      <Wrapper className='designChapterMob_contentWrapper'>
        <DesignChapter.ViewTabPane
          className='d-tabPane'
          title={props.title}
          description={props.description}
          current={props.viewType}
          onTabSelect={props.onSetTab}
        />
        {props.viewType === 'STEPS' ? (
          <StepViewComplete />
        ) : (
          <TechniqueViewComplete nextMenuValue={props.nextMenuValue}/>
        )}
        <DesignChapter.ViewWrap className='d-view'>
          <SlideTree slideTree={props.slideTree} />
        </DesignChapter.ViewWrap>
      </Wrapper>
      <Hint useHint={appylHint} />
    </DesignChapter.Wrapper>
  );
}

DesignChapterMob.propTypes = {
  /**
   * Boolean set when Notebook Drawer is collapsed
   */
  collapsed: PropTypes.bool,
  /**
   * description for the particular Slide
   */
  description: PropTypes.arrayOf(PropTypes.string),
  /**
   * title for the particular slide
   */
  title: PropTypes.string,
  /**
   * type of Slide View
   */
  viewType: PropTypes.oneOf(['STEPS', 'TECHNIQUES']).isRequired,
  /**
   * Function to call when ViewTab is selected
   */
  onSetTab: PropTypes.func.isRequired,
  /**
   * Data corrospinding to the particular design slide
   */
  slideTree: PropTypes.arrayOf(PropTypes.object),
};

DesignChapterMob.defaultProps = {
  title: '',
  description: [],
};
